import { replaceInitialValues } from 'utils/tinyMCE/replaceInitialValues'
import getThemeStylesForTemplate from 'utils/tinyMCE/templates/getThemeStylesForTemplate'
import { buildFieldsString } from 'utils/tinyMCE/buildFieldsString'

export const handleOrganizations = (
  editor,
  caseDetails,
  key,
  templates,
  dateFormat,
  selectedTheme,
) => {
  let content = ''
  const themeStyles = getThemeStylesForTemplate({ selectedTheme, editor })

  // Field keys for organization data
  const organizationFieldKeys = [
    'name',
    'sequence',
    'address1',
    'address2',
    'city',
    'state',
    'zip_code',
    'country',
    'website_url',
  ]

  caseDetails?.[key]?.forEach((orgData, i) => {
    const organizationFields = buildFieldsString(
      orgData,
      organizationFieldKeys,
      { useCaseDetailSpan: true, keyPrefix: `${key}[${i}]` },
    )
    if (organizationFields) {
      content += `
      <p style="${themeStyles}">
          ${organizationFields}
      </p><br/>
      `
    }
  })

  templates.push({
    type: 'menuitem',
    text: 'Organizations',
    onAction: () =>
      editor.execCommand(
        'mceInsertTemplate',
        false,
        replaceInitialValues(content, caseDetails),
      ),
  })
}

export default handleOrganizations
